import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from './local-storage.service';
import { ClubManagementTableService } from 'src/app/modals/ClubManagement/club-management-table.service';
import { Store } from '@ngrx/store';
import { fetchUnread } from 'src/app/modals/ClubManagement/club-management.action';
import { AgendaTaskTableService } from 'src/app/modals/AgendaTask/agenda-task-table.service';
import { fetchOpen } from 'src/app/modals/AgendaTask/agenda-task.action';
import { PermissionService } from './permission.service';

(window as any).Pusher = Pusher;


@Injectable({ providedIn: 'root' })

//This should only be imported within topbar and called init and no where else
export class EchoService {
    
    private subscribedChannels = new Set<string>();
    public echo!: Echo<any>; // Mark as late-init
    socketId: string;

    constructor(
        private permissionService: PermissionService, 
        private http: HttpClient,
        private localStorageService: LocalStorageService,
        private taskTableService: ClubManagementTableService,
        private agendaTaskTableService: AgendaTaskTableService,
        private store: Store
    ) {
    }

    initEcho(): void {

        this.echo = new Echo({
            broadcaster: 'pusher',
            key: environment.pusher.key,
            cluster: 'eu',
            forceTLS: environment.env !== "local",
            authorizer: (channel: any, options: any) => {
                return {
                    authorize: (socketId: string, callback: Function) => {
                        this.http.post(
                            `${environment.backend_web}broadcasting/auth`,
                            {
                                socket_id: socketId,
                                channel_name: channel.name,
                            },
                            { withCredentials: true }
                        ).subscribe(
                            (response) => callback(null, response),
                            (error) => callback(error)
                        );
                    }
                };
            }
        });

        this.echo.connector.pusher.connection.bind('connected', () => {
            this.socketId = this.echo.socketId();
        });
    }

    fetchTaskCount(){
        if(this.permissionService.has('communication-view') && this.permissionService.has('communication-edit'))
            this.store.dispatch(fetchUnread());
    }

    fetchOpenAgendaCount(){
        if(this.permissionService.has('tasks-view'))
            this.store.dispatch(fetchOpen());
    }

    areArraysIdentical(arr1: any[], arr2: any[]): boolean {
        if (arr1.length !== arr2.length) {
          return false;
        }
      
        const sortedArr1 = [...arr1].sort();
        const sortedArr2 = [...arr2].sort();
      
        return sortedArr1.every((value, index) => value === sortedArr2[index]);
    }

    joinTaskChannel(taskId: number, onMessage: (msg: any) => void): void {

        const channelName = `task.${taskId}`;
        // if (this.subscribedChannels.has(channelName)) return; // Already subscribed
        // this.subscribedChannels.add(channelName);

        this.echo?.private(channelName)
            .listen('.task.message.sent', (e: any) => {
                // console.log(e);
                return onMessage(e.message);
            });
    }

    joinTaskUnreadChannel(onMessage: (data: any) => void, resolveOnce?: (data: any) => void): void {

        const channelName = `task.unread.contributie`;
        // if (this.subscribedChannels.has(channelName)) return; // Already subscribed
        // this.subscribedChannels.add(channelName);

        this.echo?.private(channelName)
            .listen('.task.unread.contributie.count', (e: any) => {
                // console.log(e);
                const existingCountData: string[] = this.localStorageService.getItem("task-counter");
                if(existingCountData){
                    if(!this.areArraysIdentical(existingCountData, e.message)){
                        this.taskTableService.loadRecords();
                    }
                }

                this.localStorageService.setItem("task-counter", e.message);
                this.taskTableService.unReadTasks = e.message;
                return onMessage(e.message);
            });
    }


    joinOpenAgendaTaskChannel(onMessage: (data: any) => void): void {

        const channelName = `agenda-task.open.contributie`;
        // if (this.subscribedChannels.has(channelName)) return; // Already subscribed
        // this.subscribedChannels.add(channelName);

        this.echo?.private(channelName)
            .listen('.agenda-task.open.contributie.count', (e: any) => {
                // console.log(e);
                const existingCountData: string[] = this.localStorageService.getItem("open-agenda-task");
                if(existingCountData){
                    if(!this.areArraysIdentical(existingCountData, e.message)){
                        this.agendaTaskTableService.loadRecords();
                    }
                }

                this.localStorageService.setItem("open-agenda-task", e.message);
                this.agendaTaskTableService.openTasks = e.message;
                return onMessage(e.message);
            });
    }

}